<template>
  <div class="content-box">
    <div class="col-sm-12">
      <!--START - Grid of tablo statistics-->
      <div class="element-wrapper">
        <div class="element-actions">
          <form
            action="#"
            class="form-inline justify-content-sm-end"
            @submit="filterDataSubmit"
          >
            <input
              class="form-control form-control-sm rounded bright"
              placeholder="Busca Numero o Cliente"
              v-model="searchtext"
              type="text"
            />
            <div class="input-group-append">
              <button class="btn btn-link btn-sm" type="submit">
                <i class="fa fa-search"></i>
              </button>
              <button
                class="btn btn-link btn-sm"
                type="button"
                v-on:click="clearFilterData"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
            <br />
            <select
              class="form-control form-control-sm rounded bright"
              v-model="filterActivo"
              @change="filterData"
            >
              <option value="">Todos</option>
              <option value="C">Finalizadas</option>
              <option value="A">Abiertas</option>
              <option value="9">Anuladas</option>
            </select>
          </form>
        </div>
        <h6 class="element-header">Ordenes de Servicios</h6>
        <button
          type="button"
          @click="crearOrdenServicio"
          class="btn btn-outline-success btn-md btn-block"
        >
          Crear nueva orden de servicio
        </button>
        <br />
        <div class="element-content">
          <div class="tablo-with-chart">
            <div class="row">
              <div class="col-sm-12">
                <div class="tablos">
                  <div class="row mb-xl-2 mb-xxl-3">
                    <div
                      class="col-sm-3"
                      v-for="current in datos"
                      v-bind:key="current.id"
                    >
                      <a
                        v-if="current.estado == '9'"
                        style="background-color: #feab91"
                        class="element-box el-tablo centered trend-in-corner padded bold-label"
                        @click="rowClick(current)"
                      >
                        <div class="value">
                          {{ current.id }}
                        </div>
                        <div v-if="current.vehiculo_obj" class="label">
                          {{ current.vehiculo_obj.placa }}
                          <br />
                          <span v-if="current.vehiculo_obj.marca_obj">{{
                            current.vehiculo_obj.marca_obj.nombre
                          }}</span>
                          -
                          <span v-if="current.vehiculo_obj.linea_obj">{{
                            current.vehiculo_obj.linea_obj.nombre
                          }}</span>
                        </div>
                        <div class="trending trending-up-basic">
                          <span>
                            <timeago
                              :title="current.fecha_creacion"
                              :datetime="current.fecha_creacion"
                            ></timeago>
                          </span>
                        </div>
                      </a>
                      <a
                        v-if="current.estado == 'A'"
                        class="element-box el-tablo centered trend-in-corner padded bold-label"
                        @click="rowClick(current)"
                      >
                        <div class="value">
                          {{ current.id }}
                        </div>
                        <div v-if="current.vehiculo_obj" class="label">
                          <span v-if="current.propietario">{{
                            current.propietario
                          }}</span>
                          <br />
                          {{ current.vehiculo_obj.placa }}
                          <br />
                          <span v-if="current.vehiculo_obj.marca_obj">{{
                            current.vehiculo_obj.marca_obj.nombre
                          }}</span>
                          -
                          <span v-if="current.vehiculo_obj.linea_obj">{{
                            current.vehiculo_obj.linea_obj.nombre
                          }}</span>
                        </div>
                        <div class="trending trending-up-basic">
                          <span>
                            <timeago
                              :title="current.fecha_creacion"
                              :datetime="current.fecha_creacion"
                            ></timeago>
                          </span>
                        </div>
                      </a>
                      <a
                        v-if="current.estado == 'C'"
                        style="background-color: #70ff8a"
                        class="element-box el-tablo centered trend-in-corner padded bold-label"
                        @click="rowClick(current)"
                      >
                        <div class="value">
                          {{ current.id }}
                        </div>
                        <div v-if="current.vehiculo_obj" class="label">
                          {{ current.vehiculo_obj.placa }}
                          <br />
                          <span v-if="current.vehiculo_obj.marca_obj">{{
                            current.vehiculo_obj.marca_obj.nombre
                          }}</span>
                          -
                          <span v-if="current.vehiculo_obj.linea_obj">{{
                            current.vehiculo_obj.linea_obj.nombre
                          }}</span>
                        </div>
                        <div class="trending trending-up-basic">
                          <span>
                            <timeago
                              :title="current.fecha_creacion"
                              :datetime="current.fecha_creacion"
                            ></timeago>
                          </span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--END - Grid of tablo statistics-->
    </div>
    <div
      class="modal"
      id="ordenServicioModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Agregar detalle de orden</h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <br />
              <div class="col-sm-12">
                <label
                  v-bind:class="{
                    'text-danger':
                      current.errors && current.errors.tipo_servicio,
                  }"
                  >Vehiculo</label
                >
                <v-select
                  label="nombre"
                  v-model="current.vehiculo"
                  :filterable="false"
                  :options="vehiculos"
                  @search="onSearchVehiculo"
                  @input="selectCliente(current)"
                >
                  <template slot="no-options">vehiculo...</template>
                  <template slot="option" slot-scope="option">
                    <div v-if="option.tipo_vehiculo_obj" class="d-center">
                      <img :src="option.image" />
                      {{ option.placa }} -
                      {{ option.tipo_vehiculo_obj.nombre }} -
                      {{ option.marca_obj.nombre }} -
                      {{ option.linea_obj.nombre }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div
                      v-if="option.tipo_vehiculo_obj"
                      class="selected d-center"
                    >
                      <img :src="option.image" />
                      {{ option.placa }} -
                      {{ option.tipo_vehiculo_obj.nombre }} -
                      {{ option.marca_obj.nombre }} -
                      {{ option.linea_obj.nombre }}
                    </div>
                  </template>
                </v-select>
                <small
                  v-if="current.errors && current.errors.tipo_servicio"
                  class="form-text text-danger"
                  >{{ current.errors.tipo_servicio }}</small
                >
              </div>
              <div v-if="current.vehiculo" class="col-12">
                <label>Propietario</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="current.propietario"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-block btn-md btn-primary"
              type="button"
              @click="guardar(current)"
            >
              Nueva Orden
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="agregarVehiculo"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Agregar registro de vehículo</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <button
                  v-if="!currentDet.cliente_nit"
                  @click="abrirModalCliente"
                  type="button"
                  class="btn btn-sm btn-block btn-info"
                >
                  Agregar nuevo cliente
                </button>
              </div>
              <div class="col-sm-12 col-md-12">
                <ClientesSelectComponent
                  @onChangeCliente="refreshProp(currentDet)"
                  :current="currentDet"
                />
              </div>
              <div class="col-sm-12 col-md-12">
                <label>Placa de vehículo</label>
                <input
                  style="text-transform: uppercase"
                  type="text"
                  v-model="currentDet.placa"
                  class="form-control"
                />
              </div>
              <div class="col-sm-12 col-md-12">
                <MarcaVehiculosSelectComponent :current="currentDet" />
              </div>
              <div class="col-sm-12 col-md-12">
                <LineaVehiculosSelectComponent :current="currentDet" />
              </div>
              <div class="col-sm-12 col-md-12">
                <div class="form-group">
                  <label>Tipo vehículo</label>
                  <select
                    class="form-control"
                    autofocus="autofocus"
                    v-model="currentDet.tipo_vehiculo"
                  >
                    <option
                      v-for="(c, key) in tipo_vehiculo"
                      :value="c.id"
                      :key="key"
                    >
                      {{ c.id }} - {{ c.nombre }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-12">
                <label>Propietario</label>
                <input
                  style="text-transform: uppercase"
                  type="text"
                  class="form-control"
                  v-model="currentDet.propietario"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-block btn-md btn-primary"
              type="button"
              @click="registrarVehiculo(currentDet)"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal"
      id="modalAddCliente"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Nuevo Cliente</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit="guardarCliente">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': current.errors && current.errors.nit,
                      }"
                      >NIT</label
                    >
                    <div class="input-group">
                      <input
                        style="text-transform: uppercase"
                        v-model="current.nit"
                        autofocus="autofocus"
                        class="form-control"
                        placeholder="NIT"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.nit,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.nit"
                        class="form-text text-danger"
                        >{{ current.errors.nit[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.nombre,
                    }"
                    >Nombre</label
                  >
                  <div class="input-group">
                    <input
                      style="text-transform: uppercase"
                      v-model="current.nombre"
                      class="form-control"
                      placeholder="Nombre"
                      v-bind:class="{
                        'is-invalid': current.errors && current.errors.nombre,
                      }"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.nombre"
                      class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-12">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.direccion,
                    }"
                    >Dirección</label
                  >
                  <div class="input-group">
                    <textarea
                      style="text-transform: uppercase"
                      v-model="current.direccion"
                      class="form-control"
                      placeholder="Dirección"
                      autofocus="autofocus"
                      v-bind:class="{
                        'is-invalid':
                          current.errors && current.errors.direccion,
                      }"
                      type="text"
                    ></textarea>
                    <small
                      v-if="current.errors && current.errors.direccion"
                      class="form-text text-danger"
                      >{{ current.errors.direccion[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-12">
                  <label for>Email</label>
                  <div class="input-group">
                    <input
                      v-model="current.email"
                      class="form-control"
                      placeholder="Email"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.email"
                      class="form-text text-danger"
                      >{{ current.errors.email[0] }}</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Agregar</button>
              <button
                class="btn btn-secondary"
                ref="cerrarModalCliente"
                data-dismiss="modal"
                type="button"
              >
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import ClienteService from "@/services/catalogos/ClienteService";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";
import MarcaVehiculosSelectComponent from "@/components/commons/MarcaVehiculosSelectComponent";
import LineaVehiculosSelectComponent from "@/components/commons/LineaVehiculosSelectComponent";

export default {
  components: {
    ClientesSelectComponent,
    MarcaVehiculosSelectComponent,
    LineaVehiculosSelectComponent,
  },
  data() {
    return {
      currentDet: {
        propietario: "",
        vehiculo: "",
        placa: "",
        cliente_nit: "",
      },
      tipo_vehiculo: [],
      vehiculo: "",
      current: {
        propietario: "",
        vehiculo: "",
        placa: "",
      },
      vehiculos: [],
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: "A",
      datos: [],
      det: {},
      error: [],
    };
  },
  mounted() {
    let self = this;
    self.refreshData();
    self.refreshDataTipoVehiculo();
  },
  methods: {
    refreshProp(currentDet) {
      let self = this;
      if (currentDet.cliente_nit) {
        currentDet.propietario = currentDet.cliente_nit.nombre;
      }
    },
    abrirModalCliente() {
      $("#agregarVehiculo").modal("hide");
      $("#modalAddCliente").modal();
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDet.cliente_nit = "";
      self.currentDet.placa = "";
      self.currentDet.marca = "";
      self.currentDet.linea = "";
      self.currentDet.tipo_vehiculo = "";
    },
    registrarVehiculo(currentDet) {
      let self = this;
      self.det = currentDet;
      self.current.propietario = currentDet.propietario;
      if (self.currentDet.marca) {
        self.det.marca = self.currentDet.marca.id;
      }
      if (self.currentDet.cliente_nit) {
        self.det.cliente = self.currentDet.cliente_nit.nit;
      } else {
        alert("el campo de cliente no puede ser nulo");
        self.refreshDetalleDefault();
        $("#agregarVehiculo").modal();
        return;
      }
      if (self.currentDet.linea) {
        self.det.linea = self.currentDet.linea.id;
      }
      DynamicService.save("taller", "vehiculos", self.det)
        .then((response) => {
          $("#agregarVehiculo").modal("hide");
          self.current.vehiculo = response.data;
          self.guardar(self.current);
        })
        .catch((error) => {
          Notifications.alert.error(
            "Registrar Nuevo Vehiculo",
            error.response.data.placa[0]
          );
          self.refreshDetalleDefault();
          $("#agregarVehiculo").modal("hide");
          $("#ordenServicioModal").modal();
        });
    },
    guardarCliente(e) {
      e.preventDefault();
      let self = this;
      var current = Object.assign({}, self.current);
      delete current.image;
      if (this.$route.params.nit) {
        current.pk = this.$route.params.nit;
        delete current.nit;
      }
      if (current.lista_precio) {
        current.lista_precio = current.lista_precio.id;
      }
      ClienteService.save(current)
        .then((res) => {
          self.currentDet.cliente_nit = res.data;
          console.log(self.currentDet.cliente_nit);
          self.current.errors = {};
          Notifications.alert.confirm(
            "Cliente Agregado exitosamente",
            "¿Desea continuar continuar con la orden de servicio?",
            "Si",
            function () {
              self.currentDet.propietario = current.nombre;
              self.$refs.cerrarModalCliente.click();
              $("#agregarVehiculo").modal();
            }
          );
        })
        .catch((error) => {
          self.current.errors = Object.assign({}, error.response.data);
          if ("nit" in error.response.data) {
            Notifications.alert.error("Ups :(", error.response.data.nit[0]);
          }
        });
    },
    refreshDataTipoVehiculo() {
      let self = this;
      DynamicService.fetch("cat", "tipo-vehiculo").then((response) => {
        self.tipo_vehiculo = response.data.results;
      });
    },
    selectCliente(current) {
      let self = this;
      Vue.nextTick(function () {
        Notifications.alert.confirm(
          "¿Desea utilizar este propietario de vehiculo?",
          `"${current.vehiculo.cliente_obj.nombre}"`,
          "Si",
          function () {
            current.propietario = current.vehiculo.cliente_obj.nombre;
            self.guardar(current);
          }
        );
      });
    },
    refreshDataVehiculos() {
      let that = this;
      DynamicService.fetch("taller", "vehiculos", {
        page: 1,
      }).then((res) => {
        self.vehiculos = res.data.results;
      });
    },
    onSearchVehiculo(search, loading) {
      loading(true);
      if (search) {
        this.vehiculo = search;
      }
      this.searchVehiculo(loading, search, this);
    },

    searchVehiculo: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      DynamicService.fetch("taller", "vehiculos", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.vehiculos = res.data;
        loading(false);
      });
    }, 350),
    crearOrdenServicio() {
      let self = this;
      DynamicService.fetch("taller", "vehiculos", {
        page: 1,
      }).then((res) => {
        self.vehiculos = res.data.results;
      });
      $("#ordenServicioModal").modal();
    },
    guardar(current) {
      let self = this;
      if (!self.current.vehiculo) {
        Notifications.alert.confirm(
          "No existe este numero de placa",
          "¿Desea agregar un nuevo registro?",
          "",
          function () {
            $("#ordenServicioModal").modal("hide");
            $("#agregarVehiculo").modal();
            self.currentDet.placa = self.vehiculo;
          }
        );
      } else {
        self.det = current;
        self.det.vehiculo = self.current.vehiculo.id;
        self.det.propietario = self.current.propietario;
        DynamicService.save("taller", "orden-servicio", self.det).then(
          (response) => {
            Notifications.alert.success(
              "Orden de Servicio",
              "Se ha guardado la Información."
            );
            $("#ordenServicioModal").modal("hide");
            current.vehiculo = "";
            current.propietario = "";
            self.refreshDetalleDefault();
            self.refreshData();
          }
        );
      }
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "talleres-editar-home",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "talleres-editar-home",
          params: { id: current.id },
        });
      }
    },
    filterData() {
      this.refreshData({
        quitar_paginacion: true,
        "filter[search]": this.searchtext,
        estado: this.filterActivo,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        quitar_paginacion: true,
        "filter[search]": this.searchtext,
        estado: this.filterActivo,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData() {
      let self = this;
      self.params = { quitar_paginacion: true, estado: this.filterActivo };
      DynamicService.fetch("taller", "orden-servicio", self.params).then(
        (response) => {
          self.datos = response.data;
        }
      );
    },
    showModalEdit() {},
  },
};
</script>
